var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0 0 151 56",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151 56",
    height: 56,
    width: 151,
    "data-type": "ugc",
    role: "presentation",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0 4a4 4 0 0 1 4-4h143a4 4 0 0 1 4 4v48a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M75.65 29.38c-2.39 0-4.34 1.81-4.34 4.3a4.263 4.263 0 0 0 4.34 4.28c2.4 0 4.35-1.82 4.35-4.29a4.249 4.249 0 0 0-4.35-4.29zm0 6.9c-1.31 0-2.44-1.07-2.44-2.6 0-1.55 1.13-2.61 2.44-2.61s2.44 1.06 2.44 2.6-1.14 2.6-2.44 2.6v.01zm-9.48-6.9c-2.4 0-4.35 1.81-4.35 4.3a4.26 4.26 0 0 0 4.35 4.28c2.39 0 4.34-1.82 4.34-4.29a4.25 4.25 0 0 0-4.34-4.29zm0 6.9c-1.32 0-2.45-1.07-2.45-2.6 0-1.55 1.13-2.61 2.45-2.61 1.3 0 2.44 1.06 2.44 2.6s-1.13 2.6-2.44 2.6v.01zM54.89 30.7v1.81h4.4a3.82 3.82 0 0 1-1 2.3 4.501 4.501 0 0 1-3.4 1.32 4.802 4.802 0 0 1-4.82-4.84 4.8 4.8 0 0 1 4.83-4.84c1.45 0 2.52.56 3.3 1.3l1.3-1.28a6.44 6.44 0 0 0-4.61-1.84 6.79 6.79 0 0 0-6.82 6.67 6.8 6.8 0 0 0 6.82 6.67c2 0 3.5-.64 4.69-1.87a6 6 0 0 0 1.59-4.25c0-.43-.03-.82-.1-1.14h-6.18v-.01zM101 32.1c-.36-.95-1.46-2.73-3.7-2.73s-4.09 1.74-4.09 4.3c0 2.4 1.83 4.28 4.3 4.28a4.3 4.3 0 0 0 3.6-1.9l-1.48-.97a2.47 2.47 0 0 1-2.12 1.19 2.2 2.2 0 0 1-2.1-1.3l5.79-2.38-.2-.48v-.01zm-5.9 1.44a2.359 2.359 0 0 1 2.25-2.5c.76 0 1.4.37 1.61.9l-3.87 1.6h.01zm-4.71 4.16h1.9V25.09h-1.9v12.62-.01zm-3.11-7.37h-.08a2.999 2.999 0 0 0-2.28-.96 4.29 4.29 0 0 0-4.15 4.31c0 2.4 1.99 4.28 4.15 4.28 1.03 0 1.86-.45 2.28-.98h.07v.62c0 1.64-.89 2.52-2.31 2.52a2.4 2.4 0 0 1-2.18-1.52l-1.66.68a4.12 4.12 0 0 0 3.84 2.54c2.22 0 4.1-1.3 4.1-4.47v-7.71h-1.8v.7h.02v-.01zm-2.2 5.94c-1.3 0-2.4-1.1-2.4-2.59 0-1.51 1.1-2.61 2.4-2.61 1.3 0 2.32 1.1 2.32 2.61 0 1.5-1.01 2.59-2.31 2.59h-.01zm24.83-11.19h-4.55V37.7h1.9v-4.78h2.66c2.11 0 4.18-1.52 4.18-3.92s-2.09-3.92-4.19-3.92zm.04 6.08h-2.7v-4.33h2.7A2.198 2.198 0 0 1 112.2 29c0 .99-.8 2.17-2.23 2.17l-.02-.01zm11.75-1.8c-1.37 0-2.8.6-3.39 1.92l1.69.7c.36-.7 1.03-.93 1.73-.93.98 0 1.98.58 2 1.62v.13a4.28 4.28 0 0 0-1.99-.48c-1.82 0-3.66.99-3.66 2.84 0 1.68 1.48 2.77 3.15 2.77 1.27 0 1.99-.56 2.42-1.23h.06v.98h1.84v-4.84c0-2.24-1.68-3.49-3.85-3.49v.01zm-.23 6.9c-.63 0-1.49-.3-1.49-1.06 0-.97 1.08-1.35 2.02-1.35.83 0 1.23.19 1.72.43a2.29 2.29 0 0 1-2.25 1.99v-.01zm10.77-6.63-2.18 5.47H130l-2.26-5.47h-2.05l3.39 7.64-1.93 4.25h1.98l5.22-11.9h-2.12l.01.01zm-17.1 8.07h1.9V25.09h-1.9v12.62-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svgcid--7rxndy-6yufix)",
    d: "M16.92 15.04c-.3.32-.47.8-.47 1.42v22.32c0 .62.18 1.1.47 1.41l.07.07 12.61-12.5v-.28L17 14.97l-.08.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svgcid-j19d53cl4mwj)",
    d: "m33.8 31.94-4.2-4.17v-.3l4.2-4.17.1.05 4.98 2.8c1.42.8 1.42 2.11 0 2.92l-4.98 2.8-.1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svgcid-ve0r5z-f44s48)",
    d: "m33.9 31.88-4.3-4.26-12.68 12.57c.47.5 1.24.56 2.12.06l14.86-8.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svgcid-qdlwu15jc27q)",
    d: "m33.9 23.36-14.87-8.38c-.88-.5-1.65-.43-2.12.06l12.7 12.58 4.29-4.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M33.8 31.79 19.04 40.1c-.83.46-1.57.43-2.04.01l-.07.07.07.07c.48.43 1.21.46 2.04 0l14.87-8.38-.1-.1-.01.02z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16.92 40.05c-.3-.31-.47-.8-.47-1.41v.15c0 .62.18 1.1.47 1.41l.07-.07-.07-.08zm21.96-11.12-5.08 2.86.09.09 4.98-2.8c.7-.41 1.06-.94 1.06-1.46-.05.47-.4.95-1.05 1.3v.01z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m19.03 15.12 19.85 11.19c.64.36 1 .82 1.06 1.3 0-.52-.35-1.05-1.06-1.45L19.03 14.98c-1.43-.8-2.59-.13-2.59 1.49v.15c0-1.63 1.17-2.3 2.59-1.5z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M48.37 20.55V14.5h1.88c.93 0 1.69.28 2.25.84.55.56.84 1.29.84 2.19 0 .9-.29 1.62-.84 2.19a3.1 3.1 0 0 1-2.26.83h-1.87zm.79-.74h1.08c.7 0 1.26-.2 1.67-.6.42-.41.63-.97.63-1.7 0-.71-.2-1.26-.63-1.67a2.298 2.298 0 0 0-1.67-.6h-1.08v4.57zm5.28.74V14.5h.78v6.05h-.78zm3.9.14c-.45 0-.88-.15-1.3-.44a2 2 0 0 1-.84-1.21l.71-.28c.08.33.26.61.52.84.27.23.56.34.9.34.33 0 .63-.1.87-.26a.851.851 0 0 0 .37-.73c0-.33-.12-.6-.37-.78a3.855 3.855 0 0 0-1.15-.51 3.121 3.121 0 0 1-1.23-.66c-.27-.27-.42-.6-.42-1.03 0-.43.18-.8.52-1.13.35-.32.8-.48 1.36-.48a2 2 0 0 1 1.26.38c.32.25.54.54.63.84l-.71.3c-.05-.2-.18-.38-.38-.54-.2-.16-.46-.25-.78-.25-.3 0-.56.09-.78.26a.759.759 0 0 0-.31.62c0 .22.1.42.3.58.19.15.48.29.86.41.3.1.55.2.75.28.2.1.4.22.61.37.2.15.37.33.47.55a1.858 1.858 0 0 1-.02 1.57c-.12.23-.28.41-.49.54-.395.277-.868.42-1.35.41v.01zm3.95-.14h-.79V14.5h2.08c.52 0 .97.17 1.34.51.38.35.57.77.57 1.3 0 .51-.19.94-.57 1.29-.37.34-.82.51-1.34.51h-1.3v2.44h.01zm0-3.2h1.31c.33 0 .6-.1.8-.33.2-.22.29-.46.29-.72 0-.27-.1-.5-.3-.73-.2-.22-.46-.33-.79-.33h-1.31v2.12-.01zm9.19 2.42a3.001 3.001 0 0 1-2.24.92 3.08 3.08 0 0 1-3.13-3.16c0-.88.29-1.64.89-2.24a3 3 0 0 1 2.24-.92 3.1 3.1 0 0 1 3.15 3.16c0 .88-.31 1.63-.91 2.24zm-3.9-.5c.45.45 1 .67 1.66.67.65 0 1.21-.22 1.66-.68.45-.45.68-1.03.68-1.73a2.328 2.328 0 0 0-2.34-2.42c-.65 0-1.21.23-1.66.68a2.37 2.37 0 0 0-.68 1.74c0 .7.23 1.28.68 1.73v.01zm5.9 1.28V14.5h.96l2.97 4.71h.03l-.03-1.17V14.5h.79v6.05h-.82l-3.1-4.93h-.03l.03 1.17v3.76h-.8zm6.12 0V14.5h.77v6.05h-.78.01zm.72-6.53h-.68l.45-1.07h.85l-.62 1.07zm2.97 6.53-2.15-6.05H82l1.67 4.91h.03l1.75-4.91h.87l-2.22 6.05h-.81zm7.49-5.3H88v1.91h2.5v.73H88v1.92h2.78v.74H87.2V14.5h3.57v.75h.01zm1.22 5.3V14.5h.78v5.3h2.65v.75H92zm6.46 0V14.5h.96l2.97 4.71h.03l-.03-1.17V14.5h.78v6.05h-.81l-3.1-4.93h-.03l.03 1.17v3.76h-.8zm11.11-.78a2.998 2.998 0 0 1-2.24.92 3.087 3.087 0 0 1-2.921-1.944 3.102 3.102 0 0 1-.219-1.216c0-.88.3-1.64.9-2.24a2.997 2.997 0 0 1 2.24-.92 3.1 3.1 0 0 1 3.14 3.16 3.096 3.096 0 0 1-.9 2.24zm-3.9-.5c.45.45 1 .67 1.66.67.65 0 1.2-.22 1.66-.68.45-.45.68-1.03.68-1.73a2.32 2.32 0 0 0-.653-1.71 2.333 2.333 0 0 0-1.687-.71c-.65 0-1.21.23-1.66.68a2.377 2.377 0 0 0-.68 1.74c0 .7.23 1.28.68 1.73v.01z"
  }), /*#__PURE__*/React.createElement("defs", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 33.31,
    x2: 11.55,
    y1: 16.22,
    x1: 28.48,
    id: "svgcid--7rxndy-6yufix"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 27.62,
    x2: 16.1,
    y1: 27.62,
    x1: 40.73,
    id: "svgcid-j19d53cl4mwj"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 53.1,
    x2: 8.6,
    y1: 29.93,
    x1: 31.56,
    id: "svgcid-ve0r5z-f44s48"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 17.96,
    x2: 23.98,
    y1: 7.61,
    x1: 13.72,
    id: "svgcid-qdlwu15jc27q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGooglePlay);
export default __webpack_public_path__ + "static/media/badge-google-play.41b5152b171d9a760d89b694428318fb.svg";
export { ForwardRef as ReactComponent };